<template>
  <div class="content">
    <div class="header">
      <div
        v-for="(item,index) in labledata"
        :key="index"
        :class="{heightlight : lableindex==index}"
        @click="lableArea(index,item)"
      >
        {{item}}
        <div v-if="lableindex==index" class="xian"></div>
      </div>
    </div>
    <div class="metter" v-if="list.length!==0">
      <div class="nav" v-for="(item,index) in list" :key="index">
        <div class="navfirst">{{item.title}}</div>
        <div class="navsecond">
          <div>状态：{{item.stateName}}</div>
          <div>开始时间：{{item.begintime}}</div>
          <div>结束时间：{{item.endtime}}</div>
          <div v-if="item.isSubmit && item.isOpen">考试成绩：{{item.sumScore}} 分</div>
          <div v-else-if="item.isSubmit && item.isOpen==false">考试成绩：未公布!</div>
          <div v-else>考试成绩：未参加考试!</div>
        </div>
        <div class="navthirt">
          <el-button type="primary" plain size="small" @click="goExam(item)">立即考试</el-button>
          <!-- <el-button type="info" plain size="small">成绩排行</el-button> -->
        </div>
      </div>
    </div>
    <div v-else style="margin-top:120px">
      <nodata></nodata>
    </div>
    <div class="pagination">
      <el-pagination
        background
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage2"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        layout="total,sizes, prev, pager, next"
        :total="total"
        v-if="total>0"
      ></el-pagination>
    </div>
    <el-dialog width="70%" :visible.sync="enterDialogVisible" center @close="closeDialog">
      <EnterExamDialog v-if="enterDialogVisible" :titleExam="titleExam" :examInfoObj="examInfo"></EnterExamDialog>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog" style="font-size: 20px;">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as Personcenter from '@/api/personcenter/index';
import EnterExamDialog from './component/enterExamDialog';

export default {
  components: {
    EnterExamDialog,
  },
  data() {
    return {
      labledata: ['进行中的考试'],
      currentPage2: 1,
      lableindex: 0,
      listQuery: {
        page: 1,
        limit: 10,
        userId: this.$store.state.User.ids,
        type: 2,
      },
      list: [],
      total: 0,
      titleExam: null,
      examInfo: {},
      enterDialogVisible: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    closeDialog() {
      this.enterDialogVisible = false;
    },
    //点击立即考试
    goExam(item) {
      this.titleExam = item.title;
      this.examInfo = item;
      localStorage.setItem('Id', item.examId);
      this.enterDialogVisible = true;
    },
    getList() {
      Personcenter.getMyExam(this.listQuery).then((res) => {
        this.list = res.data;
        this.total = res.count;
      });
    },
    lableArea(index, item) {
      this.lableindex = index;
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
  },
};
</script>
<style scoped>
.content {
  width: 900px;
  /* height: 1000px; */
  padding-bottom: 20px;
}
hr {
  margin: 1px;
  border-top: 1px solid #e2e3e6;
}
.heightlight {
  color: #409eff !important;
}
.header {
  width: 850px;
  height: 35px;
  border-bottom: solid 1px #ccc;
  padding-top: 10px;
  display: flex;
}
.header > div {
  width: 150px;
  text-align: center;
  line-height: 35px;
  font-size: 16px;
  cursor: pointer;
}
.header > div:hover {
  color: #409eff;
}
.xian {
  width: 140px;
  border: solid 1px #409eff;
  margin-left: 8px;
}
.metter {
  display: flex;
  flex-wrap: wrap;
}

.nav {
  width: 400px;
  height: 200px;
  /* background-color: blue; */
  margin-top: 16px;
  border-radius: 10px;
  /* border-style: solid;
    border-color: rgba(255, 255, 255, 1);
    box-shadow: 2px 2px 5px rgba(215, 215, 215, 0.968627450980392); */
  border: 1px solid #f2f2f2;
  /* padding-left: 16px; */
  padding-top: 16px;
  margin-left: 20px;
}
/* .nav:hover{
    box-shadow:  2px 2px 5px rgba(52, 194, 250, 0.969)!important

} */
.navfirst {
  font-weight: 700;
  text-align: center;
  font-size: 16px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f2f2f2;
}
hr {
  margin-top: 10px;
}
.navsecond {
  height: 120px;
  border-bottom: 1px solid #f2f2f2;
}
.navsecond > div {
  line-height: 30px;
  /* text-align: center; */
  padding-left: 50px;
  color: #7f7f7f;
  font-size: 18px;
}
.navthirt {
  padding-top: 5px;
  text-align: center;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
</style>